/* Only confirmed company-gift inquiries are Meta Leads. Never send form values. */
(() => {
  'use strict';

  const MAX_AGE_MS = 30 * 60 * 1000;
  const RETRY_WINDOW_MS = 30 * 1000;

  function initialize(root) {
    if (root.dataset.afLeadBound || root.dataset.metaLeadEnabled !== 'true') return;
    const pixelId = root.dataset.metaPixelId || '';
    const pageId = root.dataset.leadPageId || '';
    if (!/^\d+$/.test(pixelId) || !/^\d+$/.test(pageId) || window.Shopify?.designMode) return;
    root.dataset.afLeadBound = 'true';

    const storageKey = `af:company-gifts:lead:${pageId}`;
    const confirmed = Boolean(root.querySelector('[data-af-lead-success]'));
    const form = root.querySelector('form.af-company-gifts__form');
    let timer = null;
    let stopped = false;

    function read() {
      try {
        const value = JSON.parse(window.sessionStorage.getItem(storageKey));
        if (!value || value.pixelId !== pixelId || value.pageId !== pageId ||
            typeof value.eventId !== 'string' || !value.eventId.startsWith('af-company-gifts-') ||
            !Number.isFinite(value.submittedAt) || value.submittedAt > Date.now() ||
            Date.now() - value.submittedAt > MAX_AGE_MS) return null;
        return value;
      } catch (_) { return null; }
    }

    function write(value) {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(value));
        return true;
      } catch (_) { return false; }
    }

    function clear() {
      try { window.sessionStorage.removeItem(storageKey); } catch (_) { /* Storage may be blocked. */ }
    }

    function permitted() {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        return privacy?.marketingAllowed?.() === true &&
          privacy?.analyticsProcessingAllowed?.() === true &&
          privacy?.saleOfDataAllowed?.() === true;
      } catch (_) { return false; }
    }

    function stopRetry() {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    }

    function deliver() {
      if (!confirmed || stopped) return false;
      const pending = read();
      if (!pending || pending.status !== 'pending') {
        stopRetry();
        return false;
      }
      if (!permitted() || typeof window.fbq !== 'function') return false;

      // Persist before handing off to the existing pixel to protect against refreshes/re-entry.
      if (!write({ ...pending, status: 'sent' })) return false;
      stopped = true;
      try {
        window.fbq('trackSingle', pixelId, 'Lead', {
          content_name: 'Firmengeschenke',
          content_category: 'B2B',
          form_language: pending.language,
        }, { eventID: pending.eventId });
      } catch (_) {
        stopped = false;
        write(pending);
        return false;
      }
      stopRetry();
      return true;
    }

    function startRetry() {
      if (!confirmed || stopped) return;
      const pending = read();
      if (!pending || pending.status !== 'pending') return;
      if (deliver() || timer !== null) return;
      const deadline = Date.now() + RETRY_WINDOW_MS;
      timer = window.setInterval(() => {
        if (Date.now() >= deadline) stopRetry();
        else deliver();
      }, 500);
    }

    if (!confirmed && form) {
      // A fresh or rejected form is not a conversion and invalidates an older pending attempt.
      clear();
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        if (!permitted()) {
          clear();
          return;
        }
        try {
          const randomId = window.crypto.randomUUID();
          write({
            eventId: `af-company-gifts-${randomId}`,
            submittedAt: Date.now(), status: 'pending', pixelId, pageId,
            language: root.dataset.leadLanguage === 'it' ? 'it' : 'de',
          });
        } catch (_) { /* Tracking must never interrupt the inquiry. */ }
      });
    }

    document.addEventListener('visitorConsentCollected', startRetry);
    window.addEventListener('pageshow', startRetry);
    window.addEventListener('pagehide', stopRetry);
    startRetry();

    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
          if (!error) startRetry();
        });
      } catch (_) { /* No privacy API means no tracking. */ }
    }
  }

  document.querySelectorAll('[data-af-company-gifts]').forEach(initialize);
})();
